'use strict';
angular.module('reporting.dashboards.services')
    .service('eventManager', [
    function () {
        var events = $({});
        return {
            subscribe: function () {
                events.on.apply(events, arguments);
            },
            unsubscribe: function () {
                events.off.apply(events, arguments);
            },
            publish: function () {
                events.trigger.apply(events, arguments);
            },
            once: function () {
                events.one.apply(events, arguments);
            }
        };
    }
]);
